const emailRegEx =
  /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z\-]+\.)+[A-Za-z]{2,}))$/

export const isEmailValid = email =>
  emailRegEx.test(String(email).toLowerCase())

export const isEmailValidForEnterpriseRequests = email => {
  if (
    window.location &&
    !/^\/request-demo|enterprise-quote\/?/.test(window.location.pathname)
  ) {
    return ''
  }

  const restrictedDomains = [
    'gmail.com',
    'yahoo.com',
    'outlook.com',
    'hotmail.com',
    'apple.com',
    'protonmail.com',
    '10minutemail.com',
    'me.com',
    'icloud.com',
    'googlemail.com',
    'mail.ru',
    'live.com',
    'aol.com',
    'test.com',
  ]

  const domain = email.split('@')[1]
  return restrictedDomains.find(x => x === domain.toLowerCase())
    ? 'Please provide a valid company email address'
    : ''
}
